import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabase'
import Login from './components/Login'
import LandingPage from './components/LandingPage'
import ProjectList from './components/ProjectList'
import ProjectScreen from './components/ProjectScreen'
import Catalogue from './components/Catalogue'
import QuoteScreen from './components/QuoteScreen'
import QuotesList from './components/QuotesList'
import OrdersScreen from './components/OrdersScreen'
import AppBar from './components/AppBar'

function ComingSoon({ title }) {
  return (
    <div style={{ padding: '4rem 2rem', textAlign: 'center', fontFamily: 'DM Mono, monospace', color: '#8a8579', fontSize: '0.75rem', letterSpacing: '1.5px', textTransform: 'uppercase' }}>
      {title} — coming soon
    </div>
  )
}

export default function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'DM Mono, monospace', color: '#8a8579', fontSize: '0.8rem', letterSpacing: '2px' }}>
      LOADING…
    </div>
  )

  if (!session) return <LandingPage />

  return (
    <BrowserRouter>
      <AppBar session={session} />
      <Routes>
        <Route path="/" element={<Navigate to="/projects" replace />} />
        <Route path="/projects" element={<ProjectList session={session} />} />
        <Route path="/projects/:id" element={<ProjectScreen session={session} />} />
        <Route path="/catalogue" element={<Catalogue session={session} />} />
        <Route path="/projects/:id/quote" element={<QuoteScreen session={session} />} />
        <Route path="/quotes" element={<QuotesList session={session} />} />
        <Route path="/orders" element={<OrdersScreen session={session} />} />
      </Routes>
    </BrowserRouter>
  )
}
